"use strict";

/* ========================================================================
 * Geolocation helper functions
 * ======================================================================== */


const api = {}; //Public functions

/**
 * Converts numeric degrees to radians
 *
 * @param {number} n - dLat/dLon.
 * @return {number} To rad.
 */
function toRad(n) {
	return (n * Math.PI) / 180;
}
api.toRad = toRad;

/**
 * Calculate distance between two coordinates
 *
 * @param  {number} lat1 - First latitude
 * @param  {number} lon1 - First longitude
 * @param  {number} lat2 - Second latitude
 * @param  {number} lon2 - Second longitude
 *
 * @return {number}      - Distance between two coordinates in meters
 */
function distance(lat1, lon1, lat2, lon2) {
	const R = 6371; //km
	const dLat = toRad(lat2 - lat1);
	const dLon = toRad(lon2 - lon1);

	lat1 = toRad(lat1);
	lat2 = toRad(lat2);

	const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	const d = R * c; //Distance in km
	return d * 1000; //Distance in meters
}
api.distance = distance;

/**
 * Ask device location
 *
 * @param  {function} success - Success function with the position param
 * @param  {function} error   - Error function with an error param
 *
 * @return {[type]}
 */
function locateMe(success, error) {

	const geolocationOptions = {
		enableHighAccuracy: true,
		timeout: 5000,
		maximumAge: 0
	};

	if (typeof error === "undefined") {
		error = function () {
			return false;
		};
	}

	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(success, error, geolocationOptions);
	} else {
		return error();
	}
}
api.locateMe = locateMe;

export default api;